<section class="tw-pl-4 tw-py-6 tw-flex tw-items-stretch tw-gap-4 tw-bg-white tw-overflow-x-auto">
    <header class="tw-flex tw-flex-col tw-self-stretch tw-px-2 tw-justify-center tw-w-[128px] !tw-h-full"
        (click)="viewCollection.emit(name())">
        <div class="tw-mb-4 tw-pr-5 tw-w-max">
            <img class="tw-h-20 tw-w-20"
                 alt="{{title()}}"
                 [src]="imageUrl() || 'https://cdn.cureskin.com/app/img/shop_collection_placeholder.png'" />
        </div>
        <h2 class="tw-font-lexend tw-text-500 tw-font-bold tw-leading-none tw-mb-1 tw-break-words">{{title()}}</h2>
        <p class="tw-font-body tw-text-100 tw-mb-5">{{description()}}</p>
        <cs-icon class="tw-w-8 tw-h-auto" [iconName]="'arrow_shop'" />
    </header>
    <ng-content></ng-content>
</section>